import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './dashboard/Dashboard';
import DataRequestForm from './DataRequestForm';
import AboutPage from './dashboard/AboutPage';
import RequestForm from './dashboard/RequestForm';
import DataRequestPage from './pages/DataRequestPage';
import MyRequestsPage from './pages/MyRequestsPage';
import SettingsPage from './pages/SettingsPage';
import HelpSupportPage from './pages/HelpSupportPage';
import ReportsPage from './pages/ReportsPage';
import LoginPage from './auth/LoginPage';
import { AuthProvider } from './auth/authContext';
import ProtectedRoute from './auth/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Öffentliche Route für Login */}
          <Route path="/login" element={<LoginPage />} />
          
          {/* Geschützte Routen */}
          <Route path="/" element={<Dashboard />} />
          <Route path="/antragsformular" element={
            <ProtectedRoute>
              <DataRequestForm />
            </ProtectedRoute>
          } />
          <Route path="/about" element={
            <ProtectedRoute>
              <AboutPage />
            </ProtectedRoute>
          } />
          <Route path="/request" element={
            <ProtectedRoute>
              <DataRequestPage />
            </ProtectedRoute>
          } />
          
          <Route path="/my-requests" element={
            <ProtectedRoute>
              <MyRequestsPage />
            </ProtectedRoute>
          } />
          
          <Route path="/settings" element={
            <ProtectedRoute>
              <SettingsPage />
            </ProtectedRoute>
          } />
          
          <Route path="/help" element={
            <ProtectedRoute>
              <HelpSupportPage />
            </ProtectedRoute>
          } />
          
          <Route path="/reports" element={
            <ProtectedRoute>
              <ReportsPage />
            </ProtectedRoute>
          } />
          
          <Route path="/reports/:id" element={
            <ProtectedRoute>
              <ReportsPage />
            </ProtectedRoute>
          } />
          
          {/* Standardroute zum Login umleiten */}
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
